import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';

interface DaysProps {
  daysItem: {silver: number; gold: number; diamond: number};
}

const Days: FC<DaysProps> = ({daysItem}) => {
  const {t} = useTranslation();
  return (
    <div className="flex flex-col pt-1.5 pb-3 px-3 gap-2.5">
      <h3 className="text-t2 text-sm font-semibold">
        {t('vip.tip.remainTime')}
      </h3>
      <p className="text-t3 text-sm font-normal">
        {t('vip.label.silverWeekCard')}:
        <span className="text-[#F67A30]">{daysItem.silver} Days</span>
      </p>
      <p className="text-t3 text-sm font-normal">
        {t('vip.label.goldWeekCard')}:
        <span className="text-[#F67A30]">{daysItem.gold} Days</span>
      </p>
      <p className="text-t3 text-sm font-normal">
        {t('vip.label.diamondWeekCard')}:
        <span className="text-[#F67A30]">{daysItem.diamond} Days</span>
      </p>
      <p className="text-t2 text-sm">{t('vip.tip.remainTimeBottom')}</p>
    </div>
  );
};

export default Days;
